import React from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { InputLabel } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import tr from 'date-fns/locale/tr';
import { useField, useFormikContext } from 'formik';

function FormDatePicker({
  name,
  label = 'Tarih Seç',
  placeholder = 'Tarih seç',
  value,
  onChange,
  minDate,
  maxDate,
  minDateMessage = 'Bu tarihten öncesi olamaz! (01-01-1900)',
  maxDateMessage = 'Bu tarihten sonrası olamaz! (01-01-2100)',
  ...otherProps
}) {
  const [field, meta] = useField(name);
  const { values, setFieldValue } = useFormikContext();

  const handleChange = e => {
    setFieldValue(name, e);
  };

  const DatePickerProps = {
    // disableToolbar: true,
    ...field,
    ...otherProps,
    value: values[name] || null,
    onChange: handleChange,
    variant: 'inline',
    size: 'small',
    className: 'w-full',
    format: 'dd/MM/yyyy',
    inputVariant: 'outlined',
    invalidDateMessage: 'Tarih formatı eksik ya da yanlış!',
    invalidLabel: 'Tarih formatı eksik ya da yanlış!',
    minDate,
    maxDate,
    maxDateMessage,
    minDateMessage,
    autoOk: true,
    placeholder,
    orientation: 'landscape',
    PopoverProps: {
      className: 'w-1/2'
    },
    FormHelperTextProps: {
      className: 'mx-4 mt-2 text-12'
    }
  };

  if (meta && meta.touched && meta.error) {
    DatePickerProps.error = true;
    DatePickerProps.helperText = meta.error;
  }

  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={tr}>
        <InputLabel className="mb-8 text-gray-700 font-semibold">{label}</InputLabel>
        <KeyboardDatePicker {...DatePickerProps} />
      </MuiPickersUtilsProvider>
    </>
  );
}

export default FormDatePicker;
